var React = require('react');

function Minus (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M19.167 10.833H.833a.833.833 0 1 1 0-1.666h18.334a.833.833 0 0 1 0 1.666z"}));
}

Minus.displayName = "Minus";

Minus.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Minus;

Minus.default = Minus;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/minus.svg
// module id = 1279
// module chunks = 0